import { useEffect, useState } from "react";
import styles from "./list.module.css";
import dayjs from "dayjs";
import { authData, getCompanySlug } from "../../../components/GetAuth";
import axios from "axios";
import { Link } from "react-router-dom";
import { EditOutlined, PhoneOutlined, EmailOutlined } from "@mui/icons-material";
import Loader from "../../../components/Loader";

export default function DeliveryBookingDetailsPopup({ bookingId }) {
  const auth = authData();
  const companySlug = getCompanySlug();
  const API_TOKEN = auth?.api_token;
  const [bookingData, setBookingData] = useState({});
  const [loading, setLoading] = useState(false);
  const [pickupPhones, setPickupPhones] = useState([]);

  useEffect(() => {
    const getDetails = () => {
      setLoading(true);
      axios(process.env.REACT_APP_API_URL + "v1/bookings/" + bookingId, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") {
          setLoading(false);
          let bookingDataTemp = response.data.data;
          setBookingData(bookingDataTemp);

          if (bookingDataTemp && bookingDataTemp?.pickup_details?.phone) {
            let pPhones = [];

            if (bookingDataTemp?.pickup_details?.alt_phones && bookingDataTemp?.pickup_details?.alt_phones?.length > 0) {
              pPhones = bookingDataTemp?.pickup_details?.alt_phones?.map(i => {
                return i;
              });
            }

            setPickupPhones([bookingDataTemp?.pickup_details?.phone].concat(pPhones));
          }
        } else {
          setLoading(false);
        }
      }).catch((error) => {
        setLoading(false);
      });
    }
    getDetails();
  }, [API_TOKEN, bookingId]);

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.BodyHWithIcon}`}>
      <p>Please find the details of order #{bookingData?.booking_id} below:</p>
      <div className={`${styles.BodyHeadIcon}`}>
        {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:update') > -1) && (bookingData?.status === 0 || bookingData?.status === "0" || bookingData?.status === 1 || bookingData?.status === "1") && (<Link to={"/" + companySlug + "/booking/edit-delivery-booking/" + bookingData?.id}><EditOutlined /></Link>)}
      </div>
    </div>

    <div className={`${styles.MondalBodyDeRow}`}>
      <div className={`${styles.ModalDeBigSec}`}>
        <p className={`${styles.StepBoxTitle2}`}>Customer Account Details</p>
        <ul className={`${styles.SummeryListSec}`}>
          <li>
            <p className={`${styles.SummeryHeadTitle}`}>Customer ID:</p>
            <p className={`${styles.SummeryHeadText}`}>{bookingData?.customer?.customer_id}</p>
          </li>
          <li>
            <p className={`${styles.SummeryHeadTitle}`}>Customer Name:</p>
            <p className={`${styles.SummeryHeadText}`}>{bookingData?.customer?.name}</p>
          </li>
          <li>
            <p className={`${styles.SummeryHeadTitle}`}>Customer Mobile:</p>
            <p className={`${styles.SummeryHeadText}`}>{bookingData?.customer?.phone}</p>
          </li>
          <li>
            <p className={`${styles.SummeryHeadTitle}`}>Customer Email:</p>
            <p className={`${styles.SummeryHeadText}`}>{bookingData?.customer?.email}</p>
          </li>
        </ul>
      </div>
      <div className={`${styles.ModalDeBigSec}`}>
        <p className={`${styles.StepBoxTitle2}`}>Additional Info</p>
        <ul className={`${styles.SummeryListSec}`}>
          <li>
            <p className={`${styles.SummeryHeadTitle}`}>Booking Taken by:</p>
            <p className={`${styles.SummeryHeadText}`}>{bookingData?.created_user}</p>
          </li>
          <li>
            <p className={`${styles.SummeryHeadTitle}`}>Booking Last Edited by:</p>
            <p className={`${styles.SummeryHeadText}`}>{bookingData?.edited_user}</p>
          </li>
          <li>
            <p className={`${styles.SummeryHeadTitle}`}>Items:</p>
            <p className={`${styles.SummeryHeadText}`}>{bookingData?.no_of_items} Item(s)</p>
          </li>
          <li>
            <p className={`${styles.SummeryHeadTitle}`}>Delivered by:</p>
            <p className={`${styles.SummeryHeadText}`}>{bookingData?.picked_driver?.name}</p>
          </li>
          <li>
            <p className={`${styles.SummeryHeadTitle}`}>Customer Signature:</p>
            <p className={`${styles.SummeryHeadText}`}>{bookingData?.customer_signature !== "" ? <img src={bookingData?.customer_signature} alt="" style={{ maxHeight: '30px', maxWidth: '100px' }} /> : '-'}</p>
          </li>
        </ul>
      </div>
    </div>

    <div className={`${styles.MondalBodyDeRow}`}>
      <div className={`${styles.ModalDeBigSec}`}>
        <p className={`${styles.StepBoxTitle2}`}>Delivery Photo(s)</p>
        <div className={`${styles.ImageRow}`}>
          {bookingData?.images?.map((img) => {
            return (<div className={`${styles.imgDiv}`}>
              <img src={img.image_url} alt="" />
            </div>);
          })}
        </div>
      </div>
    </div>

    <div className={`${styles.MondalBodyDeRow}`}>
      <div className={`${styles.ModalDeBigSec}`}>
        <p className={`${styles.Title}`}>Booking Note:</p>
        <p className={`${styles.Text}`}>{bookingData?.description}</p>
      </div>
      <div className={`${styles.ModalDeBigSec}`}>
        <p className={`${styles.Title}`}>Delivery Note:</p>
        <p className={`${styles.Text}`}>{bookingData?.delivery_note}</p>
      </div>
    </div>

    {(bookingData?.status === -1 || bookingData?.status === "-1") && (<div className={`${styles.BookingNote}`}>
      <p className={`${styles.Title}`}>Cancel Note:</p>
      <p className={`${styles.Text}`}>{bookingData?.cancel_note}</p>
    </div>)}

    <div className={`${styles.MondalBodyDeRow2}`}>
      <p className={`${styles.FullTitle}`}>Collection and delivery details</p>
      <div className={`${styles.ModalDeBigSec}`}>
        <p className={`${styles.StepBoxTitle2}`}>Delivery Address</p>
        <p className={`${styles.PickName}`}>{bookingData?.pickup_details?.name}</p>
        <p className={`${styles.DetailsList}`}>{bookingData?.pickup_details?.address}</p>
        <p className={`${styles.DetailsList}`}><EmailOutlined />{bookingData?.pickup_details?.email}</p>
        <p className={`${styles.DetailsList}`}><PhoneOutlined />{pickupPhones.join(', ')}</p>
      </div>
    </div>

    <div className={`${styles.MondalBodyDeRow2}`}>
      <p className={`${styles.FullTitle}`}>Item details</p>
      <div className={`${styles.ModalDeFullSec}`}>
        <p className={`${styles.StepBoxTitle2}`}>Delivery Date: {dayjs(bookingData?.pickup_date).format("ddd MMM D, YYYY")}</p>
        <div className={`${styles.TableSec}`}>
          <table>
            <tr>
              <td className={`${styles.TableHead}`} style={{ background: "#ef233c", color: "#ffffff" }}>Item ID</td>
              <td className={`${styles.TableHead}`} style={{ background: "#ef233c", color: "#ffffff" }}>Item</td>
              <td className={`${styles.TableHead}`} style={{ background: "#ef233c", color: "#ffffff" }}>Qty</td>
              <td className={`${styles.TableHead}`} style={{ background: "#ef233c", color: "#ffffff" }}>Cost</td>
              <td className={`${styles.TableHead}`} style={{ background: "#ef233c", color: "#ffffff" }}>Status</td>
            </tr>
            {bookingData?.delivery_products?.map((item, index) => {
              return (<tr key={index}>
                <td className={`${styles.TableCon}`}>{item.item_id}</td>
                <td className={`${styles.TableCon}`}>{item.product_title}</td>
                <td className={`${styles.TableCon}`}>{item.quantity}</td>
                <td className={`${styles.TableCon}`}>
                  £{parseFloat(item.subtotal).toFixed(2)}
                  {parseFloat(item.discount) > 0 && <>
                    <br />
                    <span style={{ fontSize: '11px' }}>(-£{parseFloat(item.discount).toFixed(2)})</span>
                  </>}
                </td>
                <td className={`${styles.TableCon}`}>{bookingData?.status_text}</td>
              </tr>);
            })}
          </table>
        </div>

        <div className={`${styles.EstiAmmo}`}>
          <ul>
            <li>
              <p className={`${styles.EstiTitle}`}>Item Subtotal:</p>
              <p className={`${styles.EstiInput}`}>£{parseFloat(bookingData?.amount)?.toFixed(2)}</p>
            </li>
            {(bookingData?.discount_amount > 0 && bookingData?.discount_val > 0) && (<li>
              <p className={`${styles.EstiTitle}`}>Membership Discount({bookingData?.discount_val}%):</p>
              <p className={`${styles.EstiInput}`}>-£{parseFloat(bookingData?.discount_amount)?.toFixed(2)}</p>
            </li>)}
            {bookingData?.referral_discount > 0 && (<li>
              <p className={`${styles.EstiTitle}`}>Referral Discount:</p>
              <p className={`${styles.EstiInput}`}>-£{parseFloat(bookingData?.referral_discount)?.toFixed(2)}</p>
            </li>)}
            <li>
              <p className={`${styles.EstiTitle}`}>Total VAT:</p>
              <p className={`${styles.EstiInput}`}>£0.00</p>
            </li>
            <li>
              <p className={`${styles.EstiTitle}`}>Insurance Charges:</p>
              <p className={`${styles.EstiInput}`}>£0.00</p>
            </li>

            <li>
              <p className={`${styles.EstiTitle}`}>Order Total:</p>
              <p className={`${styles.EstiInput}`}>£{parseFloat(bookingData?.total)?.toFixed(2)}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    {bookingData?.payments?.length > 0 && (<div className={`${styles.MondalBodyDeRow2}`}>
      <p className={`${styles.FullTitle}`}>Payment Details</p>
      <div className={`${styles.ModalDeFullSec}`}>
        <div className={`${styles.TableSec}`}>
          <table>
            <tr>
              <td className={`${styles.TableHead}`} style={{ background: "#ef233c", color: "#ffffff" }}>Paid Amount</td>
              <td className={`${styles.TableHead}`} style={{ background: "#ef233c", color: "#ffffff" }}>Payment Notes</td>
              <td className={`${styles.TableHead}`} style={{ background: "#ef233c", color: "#ffffff" }}>Created By</td>
              <td className={`${styles.TableHead}`} style={{ background: "#ef233c", color: "#ffffff" }}>Created Date</td>
            </tr>
            {bookingData?.payments?.map((item, index) => {
              return (<tr key={index}>
                <td className={`${styles.TableCon}`}>£{parseFloat(item.amount).toFixed(2)}</td>
                <td className={`${styles.TableCon}`}>{item.note}</td>
                <td className={`${styles.TableCon}`}>{item.name}</td>
                <td className={`${styles.TableCon}`}>{dayjs(item.created_at).format("DD/MM/YYYY LT")}</td>
              </tr>);
            })}
          </table>
        </div>
      </div>
    </div>)}
  </>);
}